import type { MenuStudentPort } from '@/components/application/ports/menu_student_port'
import type { MenuStudentModel } from '@/components/domains/menu_student_model'
import type { AppService } from '@/core/http/http-client'
import { ApiError, ErrorUtil } from '@/core/http/response_error'
import type { MenuStudentEntity } from '../entity/menu_student_entity'
import { MenuStudentMapper } from '../mappers/menu_student_mapper'
import type { ResponseResult } from '@/core/http/response-result'
import type { ResponseApi } from '@/core/http/response-api'

export class MenuStudentRepository implements MenuStudentPort {
  constructor(private httpClient: AppService) {}

  async getAllWorkshop(idUser: number): Promise<ResponseResult<MenuStudentModel[]>> {
    try {
      const result = await this.httpClient.get<ResponseApi<MenuStudentEntity[]>>(
        `/listTalleres/byUser/${idUser}`,
      )

      const response = result.data

      if (result.status === 200 && response.STATUS_CODE === 1) {
        const data = MenuStudentMapper.toFrom(response.DATA!)
        return {
          STATUS_CODE: response.STATUS_CODE,
          DATA: data,
        }
      }

      throw new ApiError({
        message: response.MESSAGE || 'Error desconocido del backend',
        bizCode: response.STATUS_CODE,
        statusCode: result.status,
      })
    } catch (error) {
      throw ErrorUtil.getError(error)
    }
  }
}
